import { render, staticRenderFns } from "./NewKlent.vue?vue&type=template&id=451f28a2&"
import script from "./NewKlent.vue?vue&type=script&lang=js&"
export * from "./NewKlent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports